import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.profile.info;

  if (isEmpty(profile)) {
    return null;
  }

  if (isEmpty(profile.address)) {
    return null;
  }
  try {
    return `${profile.address.country.value}, ${profile.address.state.label}`;
  } catch (error) {
    return null;
  }
};
//VERIFY IF THE JWT IS SET
const getMemberLocationForProfile = createSelector(
  getData,
  location => location
);
export default getMemberLocationForProfile;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberLocationForProfile.js